import React from 'react';
import { Card, DropDown, DropDownItem } from '@wajeez-web/components/ui';
import { DotsVerticalIcon } from '@heroicons/react/solid';

export type WajeezCardProps = {
  badge?: string;
  title?: string;
  desc?: string;
  headerActions?: DropDownItem[];
};

function WajeezCard({ badge, title, desc, headerActions }: WajeezCardProps) {
  return (
    <Card>
      <div className=" space-y-3 w-full ">
        <div className="flex justify-between">
          {badge ? (
            <div className="flex items-center bg-ring-color py-1 px-3 w-auto rounded-full text-xs truncate me-1">
              <div className="truncate">{badge}</div>
            </div>
          ) : null}
          {headerActions && headerActions.length > 0 ? (
            <DropDown
              Icon={DotsVerticalIcon}
              buttonType="text"
              bg="ring-color"
              shape="circle"
              color="gray-500"
              name="card header"
              list={headerActions}
            />
          ) : null}
        </div>
        <div className="justify-between">
          <div>
            <div className="text-textPrimary font-semibold text-xl truncate">
              {title}
            </div>
            <div className="w-fit inline-block text-sm text-textSecondary">
              {desc}
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </Card>
  );
}

export default WajeezCard;
